/** The physical goods that flow through the economy. Every unit is a real,
 * transported object — there is no teleportation of goods. */
export enum ResourceType {
  Wood = 'wood',
  Planks = 'planks',
  Stone = 'stone',
  IronOre = 'iron_ore',
  Coal = 'coal',
  Gold = 'gold',
  Grain = 'grain',
  Flour = 'flour',
  Bread = 'bread',
  Fish = 'fish',
  Meat = 'meat',
  Beer = 'beer',
  Tools = 'tools',
  Weapons = 'weapons',
  Armor = 'armor',
}

/** Natural deposits that can occur on a tile and be harvested. */
export enum DepositType {
  None = 'none',
  Forest = 'forest',
  StoneRock = 'stone_rock',
  IronVein = 'iron_vein',
  CoalSeam = 'coal_seam',
  GoldVein = 'gold_vein',
  FishShoal = 'fish_shoal',
}

export interface Deposit {
  readonly type: DepositType;
  /** Remaining harvestable amount; Infinity for renewable deposits (e.g. fish). */
  readonly amount: number;
}
